export const DROP_LABELS = {
  below_min_size: "too small", above_max_size: "too large", size_unverified: "headcount unknown", industry_mismatch: "other industry",
  industry_unverified: "firm not verifiable", company_unverified: "no firm named", persona_mismatch: "title outside personas",
  excluded: "excluded / own company", below_quality_gate: "weak fit", judge_rejected: "AI judge rejected",
};

export const fmtEmployees = (n) => (n ? `${Number(n).toLocaleString()} employees` : null);

export const companyLine = (p) => [p.companyIndustry, fmtEmployees(p.employeeCount), p.companyLocation].filter(Boolean).join(" · ");

export const personaBadge = (p) => {
  if (!p.personName) return { tone: "amber", text: "Decision-maker still to be identified", hint: "The firm fits; the full hunt will find and verify the named buyer." };
  if (p.personaFit === true) return { tone: "teal", text: "Title matches your personas", hint: "This title is one of the buyer personas in your targeting." };
  if (p.personaFit === null || p.personaFit === undefined) return { tone: "gray", text: "Seniority in range", hint: "The title's seniority level is inside your targeting, though it is not an exact persona match." };
  return { tone: "amber", text: "Title outside personas", hint: "This title sits outside the personas and seniority in your targeting." };
};

export const companyBadge = (p) => {
  if (p.verifiedBy) return { tone: "teal", text: `Verified · ${p.verifiedBy}`, hint: `An independent source (${p.verifiedBy}) confirmed this company exists, its industry and its size.` };
  return { tone: "amber", text: "Firm unverified", hint: "We only have this company's name from a public profile headline — no registry or company database confirmed its industry or size yet. It will be verified in the full hunt before any outreach." };
};

export const sizeBadge = (p, spec) => {
  const floor = spec?.size?.minEmployees, ceil = spec?.size?.maxEmployees;
  if (!floor && !ceil) return null;
  if (p.sizeTolerance) return { tone: "amber", text: "One size bracket outside range" };
  if (p.employeeCount || p.sizeFit) return { tone: "teal", text: "Size in range" };
  return { tone: "gray", text: "Size unknown" };
};

export const dropSummary = (dropReasons) =>
  Object.entries(dropReasons || {}).sort((a, b) => b[1] - a[1]).slice(0, 4).map(([k, n]) => `${n} ${DROP_LABELS[k] || k.replace(/_/g, " ")}`);

export const previewOutcome = (preview) => {
  if (!preview) return null;
  return {
    prospects: (preview.prospects || []).map((p) => `${p.personName || "firm"} — ${p.personTitle || ""} @ ${p.companyName || "?"} (${companyLine(p) || "no firm data"})`),
    dropReasons: preview.run?.dropReasons || {},
    searched: { companies: preview.run?.companies, people: preview.run?.anchored, raw: preview.run?.raw },
    marketSize: preview.run?.marketSize,
    blocked: preview.blocked?.blocking || null,
    guidance: preview.guidance ? { question: preview.guidance.question, hint: preview.guidance.hint, suggestions: (preview.guidance.suggestions || []).map((s) => s.label) } : null,
  };
};
